import "jquery-validation";

/*
 *
 * ----------------------------------------------- */
// jQuery Validation Plugin
// https://jqueryvalidation.org/
jQuery(function ($) {
  jQuery(".wpcf7-submit").on("click", function () {
    jQuery(".wpcf7-form-control-wrap").addClass("is-show");
  });
});
